














import Vue from 'vue';
import Component from 'vue-class-component';

import { statusApplication } from 'RootDir/common/constants';

type chipData = {
  bgColor: string;
  icon: string;
};

@Component<ChipRequest>({
  name: 'ChipRequest',
  props: {
    title: {
      type: String,
      required: true,
    },
    statusId: {
      type: [Number],
      required: true,
    },
  },
})
export default class ChipRequest extends Vue {
  statusId!: number;

  get bgColorChip() {
    return this.objectChip.bgColor;
  }

  get iconChip() {
    return this.objectChip.icon;
  }

  get objectChip(): chipData {
    let bgColor = 'brand';
    let icon = 'info';
    if (this.statusId === statusApplication.CREATED.id) {
      bgColor = 'orange-8';
      icon = 'insert_drive_file';
    }
    if (this.statusId === statusApplication.IN_WORK.id) {
      bgColor = 'brand';
      icon = 'timelapse';
    }
    if (this.statusId === statusApplication.CHECKED.id) {
      bgColor = 'green-8';
      icon = 'check';
    }
    if (this.statusId === statusApplication.SERVICE_PROVIDE.id) {
      bgColor = 'green-10';
      icon = 'beenhere';
    }
    if (this.statusId === statusApplication.DENIED.id) {
      bgColor = 'red-10';
      icon = 'block';
    }
    if (this.statusId === statusApplication.CANCEL.id) {
      bgColor = 'red-6';
      icon = 'cancel';
    }
    if (this.statusId === statusApplication.IN_PROCESS_CANCEL.id) {
      bgColor = 'red-6';
      icon = 'timelapse';
    }

    return {
      bgColor,
      icon,
    };
  }
}
